module.exports = __webpack_public_path__ + "img/add.c0a5f316.svg";